export enum MarginStatus {
  ACTIVE = 'Active',
  DISABLED = 'Disabled',
}

export enum MarginFeesSettings {
  DEFAULT = 'Default',
  CUSTOM = 'Custom',
}

export enum TariffClientType {
  INDIVIDUAL = 'INDIVIDUAL',
  CORPORATE = 'CORPORATE',
}

export interface Margin {
  id: string;
  rateSource: string;
  currencyFrom: string;
  currencyTo: string;
  feesSettings: MarginFeesSettings;
  status: MarginStatus;
  render?: Record<string, React.JSX.Element>;
}

export interface MarginAmount {
  defaultMarginId?: string;
  marginId?: string;
  fromAmount: number;
  feePercent: number;
  id?: string;
}

export interface MarginFormValues {
  targetAccountGainsId: string;
  targetAccountLossesId: string;
  rateSourceId?: string;
  amounts: MarginAmount[];
  currencyFromId?: string;
  currencyToId?: string;
  tariffId?: string;
}

export interface MarginItem {
  rateSourceId: string;
  defaultMarginId: string;
  currencyFromId: string;
  riskScoreRangeId?: string;
  organizationId?: string;
  url?: string;
  currencyFrom: {
    name: string;
  };
  currencyToId: string;
  currencyTo: {
    name: string;
  };
  tariffId: string;
  tariff: {
    name: string;
    riskScoreRangeId: string;
    type: TariffClientType;
  };
  isCustom: boolean;
  targetAccountGainsId: string;
  targetAccountLossesId: string;
  rateSource: {
    name: string;
    description: string;
    id: string;
  };
  id: string;
  amounts?: {
    edges: {
      node: MarginAmount;
    }[];
  };
  render?: Record<string, React.JSX.Element>;
}

export interface Currency {
  name: string;
  value: string;
}
